export default "__VITE_ASSET__RGutu708__"